// Paylaşımlı TCMB FX kur hook'u — tüm bileşenler aynı cache'i kullanır.
// /api/fx endpoint'inden okur, 30 dakikada bir tazeler.
import { useEffect, useState } from "react";
import { api } from "@/api/client";

let _cache = { rates: {}, date: null, ts: 0 };
const _listeners = new Set();
let _inflight = null;

async function _fetch() {
  if (_inflight) return _inflight;
  _inflight = (async () => {
    try {
      const { data } = await api.get("/fx");
      _cache = {
        rates: data?.rates || {},
        date: data?.date || null,
        ts: Date.now(),
      };
      _listeners.forEach((fn) => fn(_cache));
      return _cache;
    } catch {
      return _cache;
    } finally {
      _inflight = null;
    }
  })();
  return _inflight;
}

/** Cache'i zorla yenile (BulkPDF ve export gibi anlık işlemler için). */
export async function refreshFxRates() {
  await _fetch();
  return _cache.rates;
}

/** Verilen tutarı TL karşılığına çevirir. Kur yoksa raw döner. */
export function toTRY(amount, currency, rates = _cache.rates) {
  const ccy = String(currency || "TRY").toUpperCase();
  const num = Number(amount) || 0;
  if (ccy === "TRY" || ccy === "TL") return num;
  const info = rates?.[ccy];
  if (!info || !info.sell) return num;
  const unit = Number(info.unit) || 1;
  return (num * Number(info.sell)) / (unit || 1);
}

export function useFxRates() {
  const [state, setState] = useState(_cache);
  useEffect(() => {
    // İlk yüklemede güncel değilse fetch et (30 dk'dan eskiyse)
    const stale = !_cache.ts || Date.now() - _cache.ts > 30 * 60 * 1000;
    if (stale) _fetch();
    _listeners.add(setState);
    return () => { _listeners.delete(setState); };
  }, []);
  return {
    rates: state.rates,
    date: state.date,
    toTRY: (amount, currency) => toTRY(amount, currency, state.rates),
  };
}
